import React, { useState } from "react";
import { read, store } from "Helpers/LocalStorage";
import * as R from "ramda";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import StatusHandler from "Helpers/StatusHandler";
import MuiButton from "Components/MuiButton/MuiButton";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import { Grid, Paper } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";

const PriceButtons = [
  {
    type: "MuiButton",
    value: 5000000,
    mr: true,
  },
  {
    type: "MuiButton",
    value: 10000000,
    mr: true,
  },
  {
    type: "MuiButton",
    value: 20000000,
    mr: true,
  },
];

export default function CustomPay({ chargeCredit }) {
  const { t } = useTranslation();
  const [customPrice, setCustomPrice] = useState("");
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const customPriceValidation = {
    required: true,
    isNumeric: true,
    notZero: true,
    min: 500000,
  };

  const setValue = (name, value, validation) => {
    setCustomPrice(value);
    setFormValid({ [name]: validation });
  };

  const changeAmount = (value) => {
    setValue("customPayPrice", value, true);
  };

  const onClickChargeCredit = async (item) => {
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      setCheckValid(false);
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: 0,
          Price: customPrice,
        };
        const response = await PaymentService.postChargeCredit(data);
        let err = StatusHandler(response);
        const pay = response.data.Value;
        if (!err.isFail) {
          if (pay.IsError === false) {
            store("orderId", pay.Describ);
            window.open(pay.Link, "_self");
          } else if (pay.IsError === true) {
            showNotify({ text: pay.Describ, customClass: "error" });
          }
        }
      } catch (err) {
        console.error("[catch error]", err);
      }
    } else {
      setCheckValid(true);
    }
  };

  return (
    <Paper>
      <div className="wallet-custom-package">
        <Input
          setValue={setValue.bind(this)}
          name="customPayPrice"
          value={customPrice}
          validation={customPriceValidation}
          label={<Translator id={"customPayPrice"} />}
          placeholder={t("customPayPrice")}
          endIcon={<Translator id={"moneyUnit"} />}
          checkValid={checkValid}
          type="text"
        />
        <div className="wallet-custom-package-offers">
          {PriceButtons.map((btn, index) => {
            return (
              <div
                key={`poffers-${index + 1}`}
                onClick={() => changeAmount(btn.value)}
              >
                <Icons.PlusSquareFill />
                <span>{`${
                  btn.mr
                    ? (btn.value / 1000000).toLocaleString()
                    : btn.value.toLocaleString()
                } ${t(btn.mr ? "millionMoneyUnit" : "moneyUnit")}`}</span>
              </div>
            );
          })}
        </div>
        <div className="charge-amount-info">
          <span>{t("receivedAmount")} : </span>
          <p className="normalTitle">
            {customPrice ? (+customPrice).toLocaleString() : 0}
          </p>
          <span>{t("moneyUnit")}</span>
        </div>
        <MuiButton
          color="primary"
          title={t("payment")}
          innerIcon={<Icons.CreditCard2BackFill />}
          className="w-100"
          onClick={onClickChargeCredit}
        />
      </div>
    </Paper>
  );
}
